// Function to toggle science accordion
function toggleScienceAccordion(card) {
  var content = card.querySelector('.science-faq-answer');
  var icon = card.querySelector('.science-faq-plus-icon'); 
  if (content.style.maxHeight === '0px' || content.style.maxHeight === '') {
    // Accordion is closed or not set, we need to open it
    content.style.maxHeight = content.scrollHeight + "px";
    icon.style.transform = 'rotate(45deg)';
  } else {
    // Accordion is open, we need to close it
    content.style.maxHeight = '0px';
    icon.style.transform = 'rotate(0deg)';
  }
}

// Add event listeners to science faq-accordion elements
document.querySelectorAll('.faq-item-science').forEach(function(card) {
  card.addEventListener('click', function() {
    toggleScienceAccordion(card);
  });
});

// Initially set all science faq_body to max-height of 0
window.onload = function() {
  var allContents = document.querySelectorAll('.faq-item-science');
  allContents.forEach(function(content) {
    content.querySelector('.science-faq-answer').style.maxHeight = '0px';
  });
};


//second accordion
function toggleAccordionV3(card) {
  var content = card.querySelector('.accordion-v3-text-container');
  var iconOpen = card.querySelector('.accordion-v3-open');
  
  var isExpanded = content.dataset.expanded === 'true';

  if (!isExpanded) {
    // Expand accordion
    content.style.maxHeight = 'none'; 
    content.dataset.expanded = 'true'; 
    content.innerHTML = content.dataset.fullContent; // Show full content
    iconOpen.style.transform = 'rotate(45deg)';
  } else {
    // Collapse accordion
    content.style.maxHeight = '';
    content.dataset.expanded = 'false';
    content.innerHTML = content.dataset.trimmedContent; // Show trimmed content
    iconOpen.style.transform = 'rotate(0deg)'; 
  }
}

document.querySelectorAll('.accordion-v3-text-container').forEach(function(content) {
  var words = content.innerHTML.split(' ');
  var trimmedContent = words.slice(0, 50).join(' ') + '...'; // Trimmed content
  // Save both trimmed and full content in dataset
  content.dataset.trimmedContent = trimmedContent;
  content.dataset.fullContent = content.innerHTML;
  
  // Set expanded state based on content length
  if (words.length > 50) {
    content.innerHTML = trimmedContent; // Show trimmed content initially
    content.dataset.expanded = 'false';
  } else {
    content.dataset.expanded = 'true'; // Show full content initially if it's within the word limit
  }
});

// Add event listeners to accordion-v3 elements
document.querySelectorAll('.accordion-v3').forEach(function(card) {
  // Find the corresponding iconOpen element within each card
  var iconOpen = card.querySelector('.accordion-v3-open');
  iconOpen.addEventListener('click', function() {
    // Toggle accordion when the icon is clicked
    toggleAccordionV3(card);
  });
});


//third accordion

function toggleAccordion(card) {
  var content = card.querySelector('.faq_body'); // Corrected class name
  var icon = card.querySelector('.faq_icon'); 
  if (content.style.maxHeight !== '0px') {
    // Accordion is open, we need to close it
    content.style.maxHeight = '0px';
    icon.style.transform = 'rotate(0deg)';
  } else {
    // Accordion is closed, we need to open it
    content.style.maxHeight = content.scrollHeight + "px";
    icon.style.transform = 'rotate(45deg)';
  }
}

// Function to close all accordions
function closeAllAccordions() {
  var allCards = document.querySelectorAll('.faq_accordion');
  allCards.forEach(function(card) {
    var content = card.querySelector('.faq_body');
    var icon = card.querySelector('.faq_icon');
    content.style.maxHeight = '0px';
    icon.style.transform = 'rotate(0deg)';
  });
}

// Initially set all faq_body to max-height of 0
window.onload = function() {
  var allContents = document.querySelectorAll('.faq_body');
  allContents.forEach(function(content) {
    content.style.maxHeight = '0px';
  });
}

// Add event listeners to faq-accordion elements
document.querySelectorAll('.faq_accordion').forEach(function(card) {
  card.addEventListener('click', function() {
    // If the clicked accordion's content is already open, we don't close all accordions
    if (card.querySelector('.faq_body').style.maxHeight !== '0px') {
      toggleAccordion(card);
    } else {
      closeAllAccordions();
      toggleAccordion(card);
    }
  });
});
